export default __webpack_public_path__ + "static/media/nixy_sidebar-2.f41c65f1.png";